import { Component, Inject, OnInit } from '@angular/core';
import { CustomerContactService } from '../../customer-contact/add-new-user-cl/customer-contact.service';
import { Customer_ContactVM } from '../../customer-contact/Models/customer-contact.model';
import { CustomerService } from '../../GET_NEW_UI/services/customer.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-user-uc',
  templateUrl: './add-new-user-uc.component.html',
  styleUrls: ['./add-new-user-uc.component.scss']
})
export class AddNewUserUcComponent implements OnInit {
  CustomerList:any
  selectedCustomer:number=1
  userId:number
  constructor(  private _customerContactService:CustomerContactService,
    public dialogRef:MatDialogRef<AddNewUserUcComponent>, private _customerService:CustomerService,
    @Inject(MAT_DIALOG_DATA) public data:any,) { }

  ngOnInit() {
    this.GetCustomerDetails();
    this.userId=this.data.userId;
  }

  DialogClose(){
    this.dialogRef.close(false)

  }


  GetCustomerDetails(){
    this._customerContactService.GetCustomerDetails().subscribe(res=>{
      this.CustomerList = res;
      res.map(x=>{x.customerName
      x.customerId})
  
      console.log("this.customerlist",this.CustomerList);
  })
  }

  AddNewCustomer()
  {
   // console.log("addUserContact", this.selectedUserId)
    let params = new  Customer_ContactVM();
    params.customer_auto=this.selectedCustomer;
    params.user_auto=this.userId;
    params.equipmentid_auto=0;
    params.EvalA=true;
    params.EvalB=true;
    params.EvalC=true;
    params.EvalX=true;
    params.eq_undercarriage=true;
    params.Type='CUST';
    


    this._customerService.AddNewUser_(params).subscribe(res=>{
      console.log("result",res);
      if(res==true)
      {
        this.DialogClose();
      }
    })
  //  console.log("this.selectedUserId",this.selectedUserId);
   // console.log("this.customer ID",this.customerId);

    
  }
 
}
